export class Direction  {
    readonly DIRECTION_ASC: string = "asc";
    readonly DIRECTION_DESC: string = "desc";
}